<template>
  <div v-if="!shouldHidePurchaseTypeGroup" class="tla-form-group tla-form-group--margin-medium">
    <label class="tla-form-group__label tla-form-group__label--required">{{ purchaseTypeGroupLabel }}
      <span>*</span></label>
    <div v-if="questionLabel">
      <label  class="tla-form-group__label" for="PostcodeSearch"
        v-html="questionLabel"></label>
    </div>
    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options" :key="item.touchpointValue" :collectionName="'purchaseTypeGroup'"
        :inputId="item.touchpointValue" :inputValue="item.touchpointValue" :isSelected="item.preSelect"
        :isFullWidth="true" :validationScope="validationScope" @purchaseTypeGroup="submitPurchaseTypeGroup($event)">
        <touchpointText slot="touchpoint" :content="item.touchpointName"></touchpointText>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('purchaseTypeGroup', 'message')">
      Please select an option.
    </span>
  </div>
</template>
<script lang="ts">
import {
  Vue, Component, Prop, Inject, Provide
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import PurchaseTypeGroup from '@/enums/PurchaseTypeGroup';
import { validationService } from '@/services/ValidationService';
import Touchpoint from '../../models/Touchpoint';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import GenericTouchPointTextComponent from '../ui/GenericTouchPointTextComponent.vue';

@Component({
  components: {
    touchpoint: GenericTouchPointComponent,
    touchpointText: GenericTouchPointTextComponent
  }
})
export default class PurchaseTypeGroupComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Are you looking to buy or lease?' })
  public purchaseTypeGroupLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public forcePurchaseTypeGroup!: boolean;

  @Prop({ default: PurchaseTypeGroup.Lease })
  public selectedPurchaseTypeGroup!: PurchaseTypeGroup;

  @Prop({ default: '' })
  public questionLabel!: string;

  public options: Touchpoint[] = [
    new Touchpoint(`${PurchaseTypeGroup.Finance}`, 'Buy with Finance'),
    new Touchpoint(`${PurchaseTypeGroup.Outright}`, 'Buy the Vehicle Outright'),
    new Touchpoint(`${PurchaseTypeGroup.Lease}`, 'Lease the Vehicle')
  ];

  // Toyota or Lexus
  private readonly MANUFACTURER_IDS_TO_HIDE: number[] = [54, 29];

  public get currentManufacturerId(): number {
    return this.$store.getters['vehicleModule/currentManufacturerId'];
  }

  get shouldHidePurchaseTypeGroup(): boolean {
    return this.MANUFACTURER_IDS_TO_HIDE.includes(this.currentManufacturerId) || this.forcePurchaseTypeGroup;
  }

  public async submitPurchaseTypeGroup(value: string, resetIfNecessary: boolean = true) {
    const purchaseTypeGroupInt = parseInt(value, 10);
    await this.$store.dispatch('financeModule/submitPurchaseTypeGroup', purchaseTypeGroupInt);

    // We don't want to reset if this is an automatic selection
    if (purchaseTypeGroupInt === PurchaseTypeGroup.Outright && resetIfNecessary) {
      await this.$store.dispatch('financeModule/submitResetPurchaseTypeGroupFields');
    }
    this.validateComponent();
  }

  public validateComponent() {
    this.$validator.validateAll(this.validationScope);
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }

  public created() {
    if (this.MANUFACTURER_IDS_TO_HIDE.includes(this.currentManufacturerId)) {
      this.submitPurchaseTypeGroup(`${PurchaseTypeGroup.Lease}`);
    } else if (this.forcePurchaseTypeGroup) {
      this.submitPurchaseTypeGroup(`${this.selectedPurchaseTypeGroup}`, false);
    }
  }
}
</script>
